import React, { useEffect, useState } from "react";
import HeadingComponent from "../../components/HeadingComponent";
import CustomTable from "../../components/CustomTable";
import { getRefunds } from "./APIs/firebaseRefundApi";
import { parseFirebaseDateTime } from "../../utils/helper";

const Refunds = () => {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Customer Email",
      dataIndex: "customer_email",
      render: (_, row) => row?.metadata?.customer_email ?? "-",
    },
    {
      title: "Invoice Id",
      dataIndex: "invoice_id",
      render: (_, row) => row?.metadata?.invoice_id ?? "-",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_, record) => {
        const currency = record?.currency?.toUpperCase() || "";
        const amountInDollars = (record?.amount / 100).toFixed(2);
        return `${currency} ${amountInDollars}`;
      },
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (createdAt) => parseFirebaseDateTime(createdAt),
    },
  ];

  const getAllRefunds = async () => {
    try {
      setLoading(true);
      let response = await getRefunds();

      console.log(response);
      setRefunds(response);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllRefunds();
  }, []);

  return (
    <>
      <div className="flex_start">
        <HeadingComponent text="Refunds" />
      </div>
      <br />

      <CustomTable dataSource={refunds} columns={columns} loading={loading} />
    </>
  );
};

export default Refunds;
